import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { useStyles } from "./AddRole.css";
import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import FormLoader from "../../../../Components/FormLoader/FormLoader";

class AddRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        username: "",
        role: "",
        password: "",
        confirmPassword: "",
      },
      showPassword: false,
      showConfirmPassword: false,
      usernameError: "",
      passwordError: "",
      confirmPasswordError: "",
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  showConfirmPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: true })}
      />
    );
  };

  hideConfirmPassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: false })}
      />
    );
  };

  filterData = (data) => {
    let changedData = { ...data };
    delete changedData.confirmPassword;
    return changedData;
  };

  checkError = (username) => {
    let usernameError = username ? username : "";
    let passwordError = "";
    let confirmPasswordError = "";
    if (this.state.data.password.length < 8) {
      passwordError = "Password must be minimum of 8 characters";
    }
    if (this.state.data.confirmPassword.length < 8) {
      confirmPasswordError = "Password must be minimum of 8 characters";
    }

    if (this.state.data.password !== this.state.data.confirmPassword) {
      confirmPasswordError = "Password doesn't matched";
    }

    if (usernameError || passwordError || confirmPasswordError) {
      this.setState({ usernameError, passwordError, confirmPasswordError });
      return true;
    } else {
      this.setState({
        usernameError: "",
        passwordError: "",
        confirmPasswordError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        this.setState({ loading: true });
        let data = this.filterData(this.state.data);
        const response = await Axios.post(`${url}/api/admin/user`, data, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        if (response.data.message === "User added successfully") {
          this.setState({
            data: {
              username: "",
              role: "",
              password: "",
              confirmPassword: "",
            },
            loading: false,
          });
          this.props.getUsers();
        }
      } catch (error) {
        this.setState({ loading: false });
        if (
          error.response.data.message ===
          "User with given username already exists"
        ) {
          console.clear();
          this.checkError(error.response.data.message);
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div style={{ fontSize: 18, fontWeight: "bold" }}>
          Add New User Role
        </div>
        <form onSubmit={this.handleSubmit}>
          <TextField
            name="role"
            select
            required
            fullWidth
            label="Staff Role"
            variant="outlined"
            margin="normal"
            className={classes.inputWithMargin}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.role}
            onChange={this.handleChange}
          >
            <option value="">Select Any One</option>
            <option value="Accountant">Accountant</option>
            <option value="Librarian">Librarian</option>
          </TextField>
          <TextField
            name="username"
            type="text"
            required
            fullWidth
            label="Username"
            variant="outlined"
            margin="normal"
            error={this.state.usernameError ? true : false}
            helperText={this.state.usernameError}
            className={classes.inputWithoutMargin}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.username}
            onChange={this.handleChange}
          />
          <TextField
            name="password"
            type={this.state.showPassword ? "text" : "password"}
            label="Password"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            placeholder="Enter password provided"
            style={{ outline: "none" }}
            error={this.state.passwordError ? true : false}
            helperText={this.state.passwordError}
            className={classes.inputWithMargin}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              endAdornment: this.state.showPassword
                ? this.hidePassword()
                : this.showPassword(),
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.password}
            onChange={this.handleChange}
          />
          <TextField
            name="confirmPassword"
            type={this.state.showConfirmPassword ? "text" : "password"}
            label="Confirm Password"
            fullWidth
            required
            margin="normal"
            variant="outlined"
            placeholder="Confirm your password"
            style={{ outline: "none" }}
            className={classes.inputWithoutMargin}
            error={this.state.confirmPasswordError ? true : false}
            helperText={this.state.confirmPasswordError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              endAdornment: this.state.showConfirmPassword
                ? this.hideConfirmPassword()
                : this.showConfirmPassword(),
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.confirmPassword}
            onChange={this.handleChange}
          />
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              type="submit"
              variant="outlined"
              className={classes.buttonStyle}
            >
              Submit
            </Button>
            {this.state.loading && <FormLoader />}
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddRole)));
